import { Box, Grid } from '@mui/material'
import OWInput from 'components/OWForm/OWInput'
import { useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
    IRestaurantInfo,
    useCreateCompanyContext,
} from '../CreateCompanyContext'
import AddressDetail, { TAddressDetailRef } from './AddressDetail'
import NextButton from './NextButton'
import WhiteTextField from './WhiteTextField'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import getOverflowSectionSX from '../utils/getOverflowSectionSX'

const validate = yup.object().shape({
    email: yup.string().email().required(),
    name: yup.string().required(),
})

function RestaurantInfo() {
    const { t } = useTranslation()
    const {
        onPrev,
        onSubmitRestaurantInfo,
        restaurantInfo,
    } = useCreateCompanyContext()
    const form = useForm<IRestaurantInfo>({
        defaultValues: restaurantInfo,
        resolver: yupResolver(validate),
    })

    const addressRef = useRef<TAddressDetailRef>(null)

    const { control } = form

    const onSubmit = async (data: IRestaurantInfo) => {
        try {
            const ss = await addressRef.current?.submitForm()
            const newData = {
                ...data,
                address: ss!,
            }
            onSubmitRestaurantInfo(newData)
        } catch (error) {
            console.log('error error error: ', error)
        }
    }

    return (
        <form onSubmit={form.handleSubmit(onSubmit)}>
            <Grid container>
                <Grid
                    item
                    xs={12}
                    container
                    sx={getOverflowSectionSX}
                    spacing={2}
                >
                    <Grid item xs={12}>
                        <OWInput
                            component={WhiteTextField}
                            color="info"
                            fullWidth
                            label={
                                t('register.label.restaurant_or_company_name') +
                                ' *'
                            }
                            control={control}
                            name="name"
                            autoComplete="organization"
                        />
                    </Grid>
                    <Grid xs={12} item>
                        <OWInput
                            component={WhiteTextField}
                            color="info"
                            fullWidth
                            label={t('register.label.email') + ' *'}
                            control={control}
                            name="email"
                            autoComplete="email"
                        />
                    </Grid>
                    <AddressDetail
                        defaultAddress={restaurantInfo.address}
                        ref={addressRef}
                    />
                </Grid>
                <Box textAlign={'center'} width={'100%'}>
                    <NextButton text={'Prev'} isPrevious onClick={onPrev} />
                    <NextButton
                        text={'Next'}
                        onClick={form.handleSubmit(onSubmit)}
                    />
                </Box>
            </Grid>
            <button type="submit" style={{ display: 'none' }}></button>
        </form>
    )
}

export default RestaurantInfo
